<mat-drawer-container @fade class="example-container" [hasBackdrop]="true">
  <mat-drawer-content>
    <div class="container" style="display: none;">
      <header class="header">
        <div class="backgrounds">
          <img class="first-background-header" src="./assets/home/fondo.svg" (mousedown)="disableDragging($event)"
            alt="">
          <img class="second-background-header" src="./assets/home/geometric_figures.svg"
            (mousedown)="disableDragging($event)" alt="">
          <div class="container-logo">
            <div class="logos">
              <img class="akana white_icon" (mousedown)="disableDragging($event)"
                src="./assets/home/akana_consumer_blanco.png" alt="">
              <img class="akana blue_icon" (mousedown)="disableDragging($event)"
                src="./assets/home/akana_consumer_azul.png" alt="">
              <div class="menu">
                <p class="underline" (click)="goToUrl('security', 'Seguridad')">Seguridad</p>
                <p class="underline" (click)="goToUrl('faqs', 'preguntas frecuentes')">Preguntas frecuentes</p>
                <button (click)="goToUrl('signin', 'inicio de sesion')" class="sign-in">Iniciar sesión</button>
                <button class="sign-in" (click)="goToUrl('signin', 'Crear cuenta', {su: true})">Crear cuenta</button>
              </div>
              <img class="icon_burger" src="./assets/home/burger_menu_icon.svg" (click)="drawer.toggle()" alt="">
            </div>
          </div>
          <div class="grid-content">
            <div class="container-img">
              <div class="report-container">
                <h2 class="typewriter-title-desktop">Descubre el estado de tu salud financiera y <span
                    id="typewriter"></span></h2>
                <h2 class="typewriter-title-mobile">Descubre el estado de tu salud financiera y toma el control de tus
                  finanzas</h2>
                <button id="getReport" (click)="goToUrl('multi-signin')" class="report-button">Genera tu
                  informe</button>
              </div>
            </div>
          </div>
          <div class="mobile-background">
            <img class="poster" src="./assets/home/3.png" (mousedown)="disableDragging($event)" alt="">
            <img class="mobile" src="./assets/home/mobile.svg" (mousedown)="disableDragging($event)" alt="mobile">
            <img class="bicicle" src="./assets/home/1.png" (mousedown)="disableDragging($event)" alt="">
          </div>
        </div>
      </header>
      <div class="container-tips">
        <div class="tittle-tips">
          <h2>Akana te ayuda a entender el estado de tu Salud Financiera</h2>
        </div>
        <div class="tips">
          <div class="tip-1">
            <div class="img"><img src="./assets/home/tips/euro.svg" alt=""></div>
            <div class="text-img">Clasificamos la salud financiera en 5 categorias basados en más de 50 métricas.
            </div>
          </div>
          <div class="tip-2">
            <div class="img"><img src="./assets/home/tips/report.svg" alt=""></div>
            <div class="text-img">Obtén un informe al momento con un análisis detallado.</div>
          </div>
          <div class="tip-3">
            <div class="img"><img src="./assets/home/tips/interrogation.svg" alt=""></div>
            <div class="text-img">Te ofrecemos consejos adaptados a la situación de tus cuentas.</div>
          </div>
          <div class="tip-4">
            <div class="img"><img src="./assets/home/tips/confety.svg" alt=""></div>
            <div class="text-img">Akana es un servicio totalmente gratuito.</div>
          </div>
        </div>
      </div>
      <div class="security">
        <app-security-banner [button]="false"></app-security-banner>
      </div>
      <div class="akana-offer">
        <div class="offer-tittle">
          <p id="services" class="first">NUESTROS SERVICIOS</p>
          <h2 class="second">¿Qué te ofrece Akana?</h2>
        </div>
      </div>
      <div class="scape-nothing">
        <div class="imgs">
          <img class="fondo" id="fondo" src="./assets/home/global_position.svg" (mousedown)="disableDragging($event)"
            alt="">
        </div>
        <div class="information">
          <div class="texts">
            <h2>¡Que no se te escape nada! <br> Consigue tu informe de Salud Financiera</h2>
            <p>Genera tu informe en nuestra web y recíbelo en tu email para poder consultarlo cuando quieras.</p>
          </div>
        </div>
      </div>
      <div class="stats">
        <div class="imgs">
          <img class="fondo" src="./assets/home/stats_graphics.svg" (mousedown)="disableDragging($event)" alt="">
          <img class="stats-view" id="fondo2" src="./assets/home/stats_views.svg" (mousedown)="disableDragging($event)"
            alt="">
        </div>
        <div class="information">
          <div class="texts">
            <h2>Consulta tu informe de Salud Financiera <br>
              y controla tu curva</h2>
            <p>Revisa las estadísticas sobre tus ahorros y gastos para conseguir el equilibrio perfecto.</p>
          </div>
        </div>
      </div>
      <div class="discover-goals">
        <div class="disco-go imgs">
          <img class="fondo" src="./assets/home/global_position_background.svg" (mousedown)="disableDragging($event)"
            alt="">
          <img class="global-position-img" id="fondo3" src="./assets/home/phone.svg"
            (mousedown)="disableDragging($event)" alt="">
        </div>
        <div class="information">
          <div class="texts">
            <h2>Descubre cómo alcanzar tus metas con ayuda de nuestros tips de ahorro</h2>
            <p>Incluimos consejos orientados al ahorro y la mejora de tu salud financiera para que los puedas
              aplicar en tu día a día.</p>
          </div>
        </div>
      </div>
      <div class="video">
        <div class="video-imgs imgs">
          <div class="backgrounds">

          </div>
          <div id="fondo4" class="start-form">
            <div class="content-form">
              <div class="form">
                <p class="tittle">CONOCE MÁS SOBRE AKANA</p>
                <h2>¿Quieres saber más sobre Akana?</h2>
                <p>Descubre en este video todo lo que te ofrece este nuevo servicio para mejorartu economía en
                  el día a día y alcanzar el equilibrio perfecto.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="information">
          <video controls id="video">
            <track label="English captions" kind="captions" srclang="en" src="captions_en.vtt" default>
                Your browser does not support the video tag.
            <source src="./assets/home/video/video.mp4" type="video/mp4">
          </video>
        </div>

      </div>
      <div class="simply-banner">
        <div class="banner">
          <div class="text">
            Descubre <strong>Simple Finance</strong> y aprende a mantener <strong>tus finanzas bajo control</strong>
          </div>
          <div class="button-container">
              <a href="https://simplefinance.santanderconsumer.es/" target="_blank">
                Ir a Simple Finance
              </a>
          </div>
        </div>

      </div>
      <div class="faq-container">
        <div class="faq-tittle">
          <p class="first">LO MÁS PREGUNTADO</p>
          <p class="second">Preguntas Frecuentes</p>
        </div>
        <div class="faq {{(i === (lengthObject - 1))? 'last-faq' : ''}}"
          *ngFor="let item of dataAccess | keyvalue; let i = index" id="{{'faq_' + (i + 1)}}">
          <button id="{{'button_' + (i + 1)}}" class="accordion"
            [ngStyle]="{'border-top': (i === 0) ? 'none' : '2px solid #E9F0F2'}"
            (click)="readAccordion('button_' + (i + 1), i + 1)">{{ 'FAQS.QUESTIONS.' + (i + 1) | translate}}<i
              class="arrow down"></i></button>
          <div class="panel {{(i === (lengthObject - 1))? 'last-item' : ''}}">
            <p [innerHTML]="'FAQS.ANSWERS.' + (i + 1) | translate"></p>
          </div>
        </div>
      </div>
      <footer class="footer">
        <app-footer [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
      </footer>
    </div>
  </mat-drawer-content>
  <mat-drawer class="lateral-menu" #drawer position="end" [mode]="'over'">
    <h2>Menú</h2>
    <ul>
      <li (click)="goToUrl('signin', 'inicio de sesion')" class="sign-in">
        <img src="./assets/home/menu-lateral/profile.svg" alt="">&nbsp;&nbsp;&nbsp;Iniciar sesión
      </li>
      <li (click)="goToUrl('signin', 'Crear cuenta', {su: true})" class="sign-in">
        <img src="./assets/home/menu-lateral/profile.svg" alt=""><span class="plus-icon">+</span>&nbsp;&nbsp;&nbsp;Crear
        cuenta
      </li>
      <li (click)="goToUrl('faqs', 'preguntas frecuentes')">
        <img src="./assets/home/menu-lateral/faqs.svg" alt="">&nbsp;&nbsp;&nbsp;Preguntas frecuentes
      </li>
      <li (click)="goToUrl('security', 'Seguridad' )">
        <img src="./assets/home/menu-lateral/security.svg" alt="">&nbsp;&nbsp;&nbsp;Seguridad
      </li>


    </ul>
  </mat-drawer>
</mat-drawer-container>